import { useQuery } from '@tanstack/react-query';

import { productApi } from '../api/productApi';

export function useCategoriesProduct() {
  const { data: categoriesProductData, isLoading: isLoadingCategories } =
    useQuery({
      queryKey: ['categories'],
      queryFn: async () => {
        const data = await productApi.getCategories();

        if (!data) {
          return [];
        }

        return data;
      },
    });

  return {
    categoriesProductData,
    isLoadingCategories,
  };
}
